import React from "react";

const Button = ({
  buttonText,
  buttonIcon,
  onClick,
  buttonStyle,
  glow,
}) => {
  return (
    <div
      className={`card-button ${glow && "glow-on-hover"}`}
      style={buttonStyle || {}}
      onClick={onClick}
    >
      {buttonIcon}
      <p className="card-button-text">{buttonText || "purchase"}</p>
    </div>
  );
};
export default Button;
